module.exports = __webpack_public_path__ + "static/img/download-app.ea179bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download-app.jpg
// module id = Kr/O
// module chunks = 1